import React, {useState} from "react";
import * as $ from "jquery";
import { useTranslation } from "../../langs/useTranslation";
import HOCforFullWidthTable from '../../hoc/FullWidthTableWrapper';
import useStyles from "@/styles/commonStyle";
import {Button, Tooltip, Typography} from "@material-ui/core";
import {AddBoxRounded, AutorenewRounded, CreateNewFolderOutlined} from "@material-ui/icons";
import HasPermission from "@/components/commons/HasPermission";
import DateRangePicker from "@/components/DateRangePicker";
import {FileTableId} from "@/containers/File";

export const FileTable = ({tableRef}) => {
  const { t } = useTranslation('nubisDrive')
  return(
    <div>
      <HOCforFullWidthTable>
        <table id="uploaded-file-table" className="mdl-data-table dataTable no-footer dtr-inline" ref={tableRef}>
          <thead>
          <tr>
            <th className='file-name sorting'>{t('table.fileName')}</th>
            <th className='sorting'>{t('table.type')}</th>
            <th className='sorting'>{t('table.uploadedDate')}</th>
            <th className='sorting'>{t('table.size')}</th>
            <th className='sorting'>{t({defaultMessage: "上传者"})}</th>
            <th>{t('table.action')}</th>
          </tr>
          </thead>
        </table>
      </HOCforFullWidthTable>
    </div>
  )
}

export const FileTableActions = props => {
  const {
    handleReloadDataTable,
    handleCreateDialogOpen,
    handleCreateFolderPopoverOpen,
    createFolderPopoverOpen,
    capacity,
    storageValue,
    tooltipText,
    tableParamsRef
  } = props;
  const classes = useStyles();
  const { t } = useTranslation("common");

  const [date, setDate] = useState()

  const ifHaveStorage = () => {
    if (storageValue === "unlimited") return true;
    return capacity?.total - capacity?.used >= 0;
  };

  const submit = () => {
    $(FileTableId).DataTable()?.ajax?.reload()
  }

  const reset = () => {
    setDate(undefined)
    tableParamsRef.current = {}
    handleReloadDataTable()
  }

  const handleDatePick = e => {
    setDate(e.target.value)
    tableParamsRef.current.date = e.target.value
  }

  return (
    <div className={classes.tableTitle}>
      <Typography style={{marginRight: 16}}>
        {t({defaultMessage: '上传时间'})}
      </Typography>
      <DateRangePicker value={date} onChange={handleDatePick} />
      <Button
        variant="contained"
        color="primary"
        style={{ marginRight: 8 }}
        onClick={submit}
      >
        {t({ defaultMessage: "查询" })}
      </Button>
      <Button variant="outlined" onClick={reset}>
        {t({ defaultMessage: "重置" })}
      </Button>
    </div>
  )
};
